module.exports = __webpack_public_path__ + "static/media/BLUSH_8220.2e7bee52.jpg";